import React, { useState, useEffect } from 'react';
import Close from '../../../Reutilizaveis/CloseButton';
import MensagensBoletoGerado from './mensagensBoletoGerado';
import CardBoletos from '../../CardParcela/ResumoBoletosPendentes';

import {
  BannerGerarBoleto,
  ContainerGerarBoleto,
  BannerTitle,
} from '../styles';

const ExibirBoletoGerado = ({
  parcelasAPagar,
  parcelasSelecionadas,
  setParcelasSelecionadas,
  tema,
  setExibirBoletoGerado,
  setGerarBoleto,
  contratoSelecionado,
}) => {
  const [boleto, setBoleto] = useState('');

  useEffect(() => {
    getBoleto();
  }, []);

  const getBoleto = () => {
    let temp = parcelasAPagar.find(
      (p) => p.numeroParcela === parcelasSelecionadas[0].parcela.numeroParcela
    );
    setBoleto(temp);
  };

  return (
    <BannerGerarBoleto>
      <ContainerGerarBoleto>
        <BannerTitle color={tema.primaryColor}>
          <h1>Resumo do boleto</h1>
          <Close
            onClick={() => {
              setParcelasSelecionadas([]);
              setExibirBoletoGerado(false);
              setGerarBoleto(false);
            }}
            tamanho={'30px'}
          />
        </BannerTitle>

        <CardBoletos
          parcelas={boleto}
          contratoSelecionado={contratoSelecionado}
          tema={tema}
          geracaoBoleto
        />

        <MensagensBoletoGerado />
      </ContainerGerarBoleto>
    </BannerGerarBoleto>
  );
};

export default ExibirBoletoGerado;
